import React from 'react';
import styles from './not-found.module.scss';

function NotFoundUser() {
  return (
    <div className={styles.notFoundWrapper}>
      <div className={styles.code404}>
        404 <span role="img" aria-label="sad">😢</span>
      </div>
      <div className={styles.title}>
        Stranica nije pronađena
      </div>
      <div className={styles.message}>
        Ova stranica ne postoji ili je premestena.<br />Vratite se na početnu stranicu.
      </div>
      <a href="/" className={styles.homeBtn}>Početna</a>
    </div>
  );
}

export default NotFoundUser; 